var _path, _path2, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTooltipBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.76055C17 10.2954 16.5308 11.7959 15.6517 13.0721C14.7727 14.3483 13.5233 15.343 12.0615 15.9304C10.5997 16.5178 8.99114 16.6714 7.4393 16.372C5.88745 16.0726 4.46198 15.3334 3.34316 14.2481C2.22434 13.1628 1.4624 11.78 1.15372 10.2746C0.845037 8.76917 1.00348 7.20877 1.60898 5.79072C2.21448 4.37266 3.23986 3.16063 4.55545 2.30789C5.87104 1.45515 7.41774 1 8.99999 1C11.1217 1 13.1566 1.81763 14.6568 3.27301C16.1571 4.7284 17 6.70233 17 8.76055Z",
    stroke: "#001698",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99609 4.88184L8.9961 9.73219",
    stroke: "#001698",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.85547,
    cy: 13.057,
    rx: 1,
    ry: 0.97007,
    fill: "#001698"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipBlue);
export default __webpack_public_path__ + "static/media/tooltip_blue.4f945dea087361c744d3f37dc778006a.svg";
export { ForwardRef as ReactComponent };